import React from 'react'

const FooterComponent = () => {
  return (
    <footer className="my-footer">
      <small>
        &copy; 2023 Zurea Shop by
        <a target="_blank" rel="noopener noreferrer" href="https://webdevelopermaxi.eu.org">
          <span> Maxi </span>
        </a>
        . All Rights Reserved.
      </small>
    </footer>
  );
}

export default FooterComponent;
